import { render, staticRenderFns } from "./listaAttivita.vue?vue&type=template&id=a9ca171e"
import script from "./listaAttivita.vue?vue&type=script&lang=js"
export * from "./listaAttivita.vue?vue&type=script&lang=js"
import style0 from "./listaAttivita.vue?vue&type=style&index=0&id=a9ca171e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports